/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayPeriod } from './PayPeriod';
import {
    PayPeriodFromJSON,
    PayPeriodFromJSONTyped,
    PayPeriodToJSON,
    PayPeriodToJSONTyped,
} from './PayPeriod';

/**
 * 
 * @export
 * @interface UpdatePayPeriodResponse
 */
export interface UpdatePayPeriodResponse {
    /**
     * 
     * @type {PayPeriod}
     * @memberof UpdatePayPeriodResponse
     */
    data: PayPeriod;
}

/**
 * Check if a given object implements the UpdatePayPeriodResponse interface.
 */
export function instanceOfUpdatePayPeriodResponse(value: object): value is UpdatePayPeriodResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdatePayPeriodResponseFromJSON(json: any): UpdatePayPeriodResponse {
    return UpdatePayPeriodResponseFromJSONTyped(json, false);
}

export function UpdatePayPeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePayPeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayPeriodFromJSON(json['data']),
    };
}

  export function UpdatePayPeriodResponseToJSON(json: any): UpdatePayPeriodResponse {
      return UpdatePayPeriodResponseToJSONTyped(json, false);
  }

  export function UpdatePayPeriodResponseToJSONTyped(value?: UpdatePayPeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayPeriodToJSON(value['data']),
    };
}

